import Autoplay from 'embla-carousel-autoplay';
import useEmblaCarousel from 'embla-carousel-react';
import { NextButton, PrevButton } from '../embla/EmblaArrow';
import { useCallback, useEffect, useState } from 'react';
import Image from 'next/image';
import img from '@/public/img/homepageImg.jpg';

type Props = {
  data: Array<Room>;
};

export type Room = {
  image: string;
  name: string;
};

const Carousel = ({ data }: Props) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(
    { loop: true, align: 'start', slidesToScroll: 1, breakpoints: { '(min-width: 1280px)': { slidesToScroll: 2 } } },
    [Autoplay({ delay: 3000 })]
  );
  const [prevBtnEnabled, setPrevBtnEnabled] = useState(false);
  const [nextBtnEnabled, setNextBtnEnabled] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [scrollSnaps, setScrollSnaps] = useState<number[]>([]);

  const scrollTo = useCallback((index: number) => emblaApi && emblaApi.scrollTo(index), [emblaApi]);
  const scrollNext = useCallback(() => emblaApi && emblaApi.scrollNext(), [emblaApi]);

  const onSelect = useCallback(() => {
    if (!emblaApi) return;
    setSelectedIndex(emblaApi.selectedScrollSnap());
    setPrevBtnEnabled(emblaApi.canScrollPrev());
    setNextBtnEnabled(emblaApi.canScrollNext());
  }, [emblaApi, setSelectedIndex]);

  useEffect(() => {
    if (!emblaApi) return;
    onSelect();
    setScrollSnaps(emblaApi.scrollSnapList());
    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
  }, [emblaApi, setScrollSnaps, onSelect]);
  return (
    <div className='embla h-64 w-full emblaPriceList pr-10 xl:pr-0 relative'>
      <NextButton onClick={scrollNext} enabled={nextBtnEnabled} />
      <div className='embla__viewport h-full' ref={emblaRef}>
        <div className='embla__container h-full'>
          {data?.map((room, index) => (
            <div key={index} className='embla__slide'>
              <div className='priceListImgOverlay'></div>
              <span className='text-white absolute left-12 font-semibold bottom-6 z-10'>{room.name}</span>
              <Image src={room.image} alt='' style={{ objectFit: 'cover' }}></Image>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
